import React from 'react';
import './Banner.css'; 
import banner1 from '../../Assets/Images/banner1.webp'; 
import banner2 from '../../Assets/Images/banner2.webp'; 

const Banner = () => {
  return (
    <> 
      <div className="banner">
        <img src={banner1} alt="Festive Offer" className="banner__image" />   
      </div>

      <div className="banner-container">
        <div className="banner-content">
          <h2 className="banner-heading">HERE'S WHAT'S HAPPENING</h2>
        </div>
        <div className="banner-images">
          <img src={banner2} alt="Rashki Bags" className="banner-image" /> 
        </div>
      </div>
    </>
  );
};

export default Banner;
